// src/pages/About.js

import React from 'react';
import { Box, Typography, Card, CardContent, Button, Container, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Fade, Slide, Zoom } from 'react-awesome-reveal';

// Import images from src/assets
import whoAreWeImage from '../assets/who-are-we-image.jpg';
import ourMissionImage from '../assets/our-mission-image.jpg';
import aiAndMlImage from '../assets/Ai-Ml.jpg';
import contentData from './ContentData';

const About = () => {
  const navigate = useNavigate();

  const navigateToContact = () => {
    navigate('/contact');
  };

  return (
    <Container maxWidth="lg">
      {/* Who Are We Section */}
      <Box my={4} textAlign="center">
        <Slide direction="down" triggerOnce={false}>
          <Typography variant="h3" gutterBottom color="primary">
            {contentData.whoAreWe.title}
          </Typography>
        </Slide>
        <Fade delay={300} triggerOnce={false}>
          <Typography variant="body1" color="primary">
            {contentData.whoAreWe.description}
          </Typography>
        </Fade>
        <Zoom delay={500} triggerOnce={false}>
          <Box
            component="img"
            src={whoAreWeImage}
            alt="Who Are We"
            sx={{ mt: 4, borderRadius: '10px', maxHeight: 350, maxWidth: '100%' }}
          />
        </Zoom>
      </Box>

      {/* Our Mission Section */}
      <Box my={4} textAlign="center">
        <Slide direction="up" triggerOnce={false}>
          <Typography variant="h4" gutterBottom color="primary">
            {contentData.ourMission.title}
          </Typography>
        </Slide>
        <Fade delay={300} triggerOnce={false}>
          <Typography variant="body1" color="primary">
            {contentData.ourMission.description}
          </Typography>
        </Fade>
        <Zoom delay={500} triggerOnce={false}>
          <Box
            component="img"
            src={ourMissionImage}
            alt="Our Mission"
            sx={{ mt: 4, borderRadius: '10px', width: '100%', height: 350, objectFit: 'cover' }}
          />
        </Zoom>
      </Box>

      {/* What Sets Us Apart Section */}
      <Box my={4} textAlign="center">
        <Slide direction="down" triggerOnce={false}>
          <Typography variant="h4" gutterBottom color="primary">
            {contentData.whatSetsUsApart.title}
          </Typography>
        </Slide>
        <Stack spacing={4} direction={{ xs: 'column', md: 'row' }} justifyContent="center" my={4}>
          {contentData.whatSetsUsApart.map((item, index) => (
            <Fade key={index} delay={200 * index} triggerOnce={false}>
              <Card
                sx={{
                  transition: 'transform 0.3s',
                  '&:hover': { transform: 'scale(1.05)', boxShadow: '0 4px 20px rgba(0,0,0,0.2)' },
                  maxWidth: 300,
                }}
              >
                <CardContent>
                  <Typography variant="h5" color="textPrimary">{item.title}</Typography>
                  <Typography variant="body1" color="textPrimary">{item.description}</Typography>
                </CardContent>
              </Card>
            </Fade>
          ))}
        </Stack>
      </Box>

      {/* AI and ML Section */}
      <Box my={4}>
        <Slide direction="left" triggerOnce={false}>
          <Typography variant="h4" gutterBottom color="primary">
            {contentData.aiAndMl.title}
          </Typography>
        </Slide>
        <Stack spacing={4} direction={{ xs: 'column', md: 'row' }} alignItems="center">
          <Fade delay={200} triggerOnce={false}>
            <Typography variant="body1" color="primary">
              {contentData.aiAndMl.description}
            </Typography>
          </Fade>
          <Zoom delay={500} triggerOnce={false}>
            <Box
              component="img"
              src={aiAndMlImage}
              alt="AI and ML"
              sx={{ borderRadius: '10px', maxHeight: 350, maxWidth: '100%' }}
            />
          </Zoom>
        </Stack>
      </Box>

      {/* Our Approach Section */}
      <Box my={4} textAlign="center">
        <Slide direction="down" triggerOnce={false}>
          <Typography variant="h4" gutterBottom color="primary">
            {contentData.ourApproach.title}
          </Typography>
        </Slide>
        {contentData.ourApproach.description.map((item, index) => (
          <Fade key={index} delay={300 * index} triggerOnce={false}>
            <Typography variant="body1" color="primary">
              <strong>{item.subtitle}</strong> {item.text}
            </Typography>
          </Fade>
        ))}
      </Box>

      {/* Crafting Tomorrow Section */}
      <Box my={4} textAlign="center">
        <Slide direction="up" triggerOnce={false}>
          <Typography variant="h4" gutterBottom color="primary">
            {contentData.craftingTomorrow.title}
          </Typography>
        </Slide>
        <Fade delay={300} triggerOnce={false}>
          <Typography variant="body1" color="primary">
            {contentData.craftingTomorrow.description}
          </Typography>
        </Fade>
        <Fade delay={500} triggerOnce={false}>
          <Button variant="contained" color="primary" size="large" onClick={navigateToContact} sx={{ mt: 3 }}>
            {contentData.craftingTomorrow.buttonText}
          </Button>
        </Fade>
      </Box>
    </Container>
  );
};

export default About;
